import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, catchError, EMPTY } from 'rxjs';

import { AppState } from './models/app.models';
import { errorHappened } from './store/actions';

@Injectable()
export class CartHttpInterceptor implements HttpInterceptor {
  constructor(private store: Store<AppState>) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err) => {
        if (req.url.includes('cart-v2')) {
          this.store.dispatch(
            errorHappened({
              translatedValidationMessages: err?.error?.translatedValidationMessages ?? [],
            }),
          );

          return EMPTY;
        }

        throw err;
      }),
    );
  }
}
